module.exports = __webpack_public_path__ + "assets/img/home-customer-choice-en.46ddf5df.png";